import { Directive, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { getDowntimeMessage } from '../../+state';
import { WhitelabelImage } from '../../models';

@Directive()
export abstract class DowntimeBaseComponent {
  readonly whitelabelImage: typeof WhitelabelImage = WhitelabelImage;

  #store = inject(Store);
  #downtimeMessage = this.#store.selectSignal(getDowntimeMessage);

  get downtimeMessage(): Signal<string> {
    return this.#downtimeMessage;
  }
}
